import { ABTestRecordGroup, AbTestRequest, AbTestResponse, PreGenerateAbTestRequest } from 'types/ab-test';
import { apiRequest, constructUrlWithQueryParams } from '@utils/request';
import { getDistinctId, trackMixpanel, trackMixpanelWithCallback } from '@utils/analytics';
import { getItemFromSessionStorage, setItemInSessionStorage } from '@utils/web-storage';

export async function saveAbTestGroup(abTestGroup: ABTestRecordGroup): Promise<void> {
	await apiRequest.post(`/ab-test/record`, abTestGroup);
}

function getStorageKey(testName: string, mixpanelId: string): string {
	return testName + mixpanelId;
}

export async function isUserInTestGroup(testName: string, groupName: string): Promise<boolean> {
	return await getAbTestGroup(testName) === groupName;
}

export async function getAbTestGroup(testName: string): Promise<string | undefined> {
	const mixpanelId = getDistinctId();

	try {
		if (mixpanelId) {
			const localStorageValue = getItemFromSessionStorage(getStorageKey(testName, mixpanelId));
			if (localStorageValue) {
				return localStorageValue;
			}

			const abTestRequest: AbTestRequest = {
				mixpanelId: mixpanelId,
				clientId: window.fundriseApp.apiClientId,
				testName: testName
			};
			const response = await apiRequest.get(constructUrlWithQueryParams('/ab-test', abTestRequest));
			const responseData: AbTestResponse = response.data;

			if (responseData.active) {
				setItemInSessionStorage(getStorageKey(testName, mixpanelId), responseData.group);

				trackMixpanel('Web AB Test', {
					Group: responseData.group,
					'Test Name': responseData.testName,
					'Initial Enrollment': responseData.initialEnrollment
				});
			}

			return responseData.group;
		} else {
			const preGenRequest: PreGenerateAbTestRequest = {
				testName: testName
			};
			const response = await apiRequest.get(constructUrlWithQueryParams('/ab-test/pre-generate', preGenRequest));
			const responseData: AbTestResponse = response.data;

			if (responseData.active) {
				const mixpanelCallback = function () {
					const distinctid = getDistinctId();
					if (distinctid !== undefined) {
						const abTestGroup: ABTestRecordGroup = {
							mixpanelId: distinctid,
							clientId: window.fundriseApp.apiClientId,
							testGroup: responseData.group,
							testName: responseData.testName
						};

						setItemInSessionStorage(getStorageKey(testName, distinctid), responseData.group);
						saveAbTestGroup(abTestGroup);
					}
				};

				trackMixpanelWithCallback(
					'Web AB Test',
					{
						Group: responseData.group,
						'Test Name': responseData.testName,
						'Initial Enrollment': responseData.initialEnrollment,
						pregenerated: true
					},
					mixpanelCallback
				);
			}

			return responseData.group;
		}
	} catch (e) {
		return undefined;
	}
}
